// errors
export const ERROR_FAILED_GET_TESTS = 'failed to load tests';
export const ERROR_FAILED_LOAD_METRICS = 'failed to load test metrics';
export const ERROR_FAILED_LOAD_ORGANIZATION = 'failed to load organization';
export const ERROR_FAILED_LOAD_ERRORS = 'failed to load aggregated errors';
export const ERROR_FAILED_LOAD_AGGREGATED_TEST_NAMES = 'failed to load aggregated test names';
export const ERROR_FAILED_LOAD_TEST_TRENDS = 'failed to load test trends';
export const ERROR_FAILED_LOAD_PAST_TRENDS = 'failed to load past trends';
